import { SamwinLineStatusRemoteDto } from '../../../../generated/signalR/samwin-line-status-remote-dto';

export class MessagesLinesChanged {
   public static readonly type = '[SamwinMessageLines] message lines changed';

   constructor(public sourceLine: SamwinLineStatusRemoteDto) {}
}
